import React from "react";
import { connect } from "react-redux";
import NotificationPanel from "./NotificationPanel";

const MainPane = props => {
  let { children, authenticated, dispatch, notification } = props;
  let klasses = "app-content";
  if (!authenticated) {
    klasses = "container app";
  }
  return (
    <div>
      <div className={klasses}>
        <NotificationPanel dispatch={dispatch} notification={notification} />
        {children}
      </div>
    </div>
  );
};
//todo fill body with items from state that should be displayed
const mapStateToProps = (state, ownProps) => {
  return {
    notification: state.notifications
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainPane);



// WEBPACK FOOTER //
// ./src/components/MainPane.js